var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"width":"1200px","margin":"35px auto 0px auto","padding":"35px 20px 50px","flex-flow":"row"}},[_c('div',{staticClass:"main-content"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }